import React from 'react';
import { Select } from 'htlib-copy';

import customTypes from 'types';
import { entitiesToSelectItems } from 'utils/select';

import { useUrlParam } from './utils';

import './Filters.scss';

const NO_FOR_ALL = { caption: 'No for all', value: 'no_for_all' };
export default function Filters({ entities }) {
  const { setUrlParam, getUrlParam, deleteUrlParam } = useUrlParam();

  const currentIndex = getUrlParam('index');
  const currentEntityId = getUrlParam('entity');

  const currentEntity = entities.find(({ id }) => id === currentEntityId) || {};
  const { indexes: indexesOfEntity = [] } = currentEntity;

  return (
    <div className="Filters">
      <h3 className="sectionTitle">Filters</h3>
      <div className="Filters__selects">
        <Select
          withSearch
          placeholder="-- Entity --"
          items={[NO_FOR_ALL, ...entitiesToSelectItems(entities)]}
          onSelect={value => {
            if (value === 'no_for_all') {
              deleteUrlParam('entity');
              deleteUrlParam('tags');
              setUrlParam('tags', value);
            } else {
              deleteUrlParam('tags');
              deleteUrlParam('entity');
              setUrlParam('tags', 'yes');
              setUrlParam('entity', value);
            }
            deleteUrlParam('page');
          }}
          selectedValue={currentEntityId || 'no_for_all'}
        />
        <Select
          items={indexesOfEntity}
          onSelect={indexName => {
            setUrlParam('index', indexName);
          }}
          placeholder="-- Index --"
          selectedValue={currentIndex}
        />
      </div>
    </div>
  );
}

Filters.propTypes = {
  entities: customTypes.misc.missionEntities.isRequired,
};
